import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import AmendmentChanges from '~/components/AmendmentChanges/AmendmentChanges';
import { useLocaleKeys } from '~/i18n';
export default function AmendmentChangesInAgreementView(props) {
    const { t: texts } = useLocaleKeys('pages.agreementMinisite');
    const { autoApprovalDate } = props, rest = _object_without_properties(props, [
        "autoApprovalDate"
    ]);
    return /*#__PURE__*/ _jsx(AmendmentChanges, _object_spread({
        disableDiscard: true,
        disableRequiresApprovalBadges: true,
        disableApprovalInfoBox: !autoApprovalDate,
        title: texts.amendmentChangesTitle(),
        autoApprovalDate: autoApprovalDate
    }, rest));
}
